import { Link, useLocation } from "wouter";
import { cn } from "@/lib/utils";
import {
  LayoutDashboard,
  Kanban,
  CheckCircle,
  BookUser,
  MoreHorizontal,
} from "lucide-react";

const mobileNavItems = [
  { name: "Home", href: "/", icon: LayoutDashboard },
  // /deals went out with the Deals page in the March 2026 cleanup. Projects is
  // where the deal pipeline actually lives — stages, milestones and the
  // teaser/NDA/CIM/IOI/LOI funnel — and it is what the mobile PWA's own
  // Pipeline screen renders.
  { name: "Pipeline", href: "/projects", icon: Kanban },
  { name: "Tasks", href: "/tasks", icon: CheckCircle },
  { name: "Contacts", href: "/contacts", icon: BookUser },
  { name: "More", href: "/more", icon: MoreHorizontal },
];

export function MobileNav() {
  const [location] = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border md:hidden safe-area-bottom" data-testid="mobile-nav">
      <div className="flex items-center justify-around h-16 px-2">
        {mobileNavItems.map((item) => {
          const isActive = item.href === "/" 
            ? location === "/" 
            : location.startsWith(item.href);
          const Icon = item.icon;

          return (
            <Link
              key={item.name}
              href={item.href}
              className={cn(
                "flex flex-col items-center justify-center flex-1 h-full gap-1 transition-colors min-w-0 touch-manipulation",
                isActive
                  ? "text-primary-text"
                  : "text-muted-foreground active:text-foreground"
              )}
              data-testid={`mobile-nav-${item.name.toLowerCase()}`}
            >
              <Icon className={cn("w-5 h-5 flex-shrink-0", isActive && "text-primary-text")} />
              <span className={cn(
                "text-[10px] font-medium truncate",
                isActive && "text-primary-text font-semibold"
              )}>
                {item.name}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
